<!-- 测评表展示 -->
<template>
  <div class="container">
    <div class="menu">
      <div class="items">
        <div v-if="forms.length">
          <div
            class="item"
            @click="switchForm(i.id, index)"
            v-for="(i, index) in forms"
            :key="index"
            :class="[{ active: currentFormIndex == index }]"
          >
            <i class="el-icon-document-checked" style="margin-right: 3px"></i>
            {{ i.name }}
          </div>
        </div>
        <div v-else class="empty-menu">暂无数据</div>
      </div>

      <div class="add" @click="dialogShow('创建')" v-role="['owner', 'admin']">
        <i class="el-icon-circle-plus-outline"></i>
        新增测评表
      </div>
    </div>
    <div class="form-container">
      <div class="form" v-if="forms.length">
        <div class="title">
          {{ forms[currentFormIndex].name }}
          <i
            v-role="['owner', 'admin']"
            @click="dialogShow('修改', currentFormIndex)"
            class="el-icon-edit editing"
            style="cursor: pointer"
          >
          </i>
        </div>
        <div class="infos">
          <div>
            <span class="label">初始分数：</span
            >{{ forms[currentFormIndex].init_score }}
            分
          </div>
          <div>
            <span class="label">创建时间：</span
            >{{ forms[currentFormIndex].created_at }}
          </div>
          <div>
            <span class="label"
              >备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</span
            >
            {{ forms[currentFormIndex].comment }}
          </div>
        </div>
        <div v-if="rules.length" class="rules">
          <EvaluationRule
            v-for="(item, index) in rules"
            :rule="item"
            :key="item.id"
            :index="index"
            @updated="getEvaluationRuleTree"
          >
          </EvaluationRule>
          <div
            class="add"
            @click="handleRuleCreate(null)"
            v-role="['owner', 'admin']"
          >
            <i class="el-icon-plus"></i> 新增测评规则
          </div>
        </div>
        <div v-else class="empty-data" @click="handleRuleCreate(null)">
          <i class="el-icon-plus"></i> 暂无数据，先新增一条
        </div>
      </div>
      <div v-else class="empty-data" @click="handleRuleCreate(null)">
        <i class="el-icon-plus"></i> 暂无数据，先新增一条
      </div>
    </div>
    <AddDialog ref="dialog" @saveValue="saveValue" />
    <CreateUpdateDialog
      :visible.sync="cuDialogVisible"
      :data="ruleForm"
      @submited="getEvaluationRuleTree"
    >
    </CreateUpdateDialog>
  </div>
</template>
<script>
import AddDialog from "./evaluation-add.vue";
import CreateUpdateDialog from "./create-update-dialog.vue";
import EvaluationRule from "./evaluation-rule.vue";
import {
  getEvaluationRuleTree,
  // reorderEvaluationRule,
} from "@/api/evaluation-rule";

import {
  getEvaluationFormList,
  createEvaluationForm,
  editEvaluationForm,
} from "@/api/evaluation-form";

import defaultForm from "./default-form.json";

export default {
  data() {
    return {
      rules: [],
      forms: [],
      currentFormIndex: 0,
      cuDialogVisible: false,
      ruleForm: defaultForm,
    };
  },
  computed: {
    currentForm() {
      if (this.forms.length <= this.currentFormIndex) return null;
      return this.forms[this.currentFormIndex];
    },
  },
  created() {
    this.getEvaluationFormList();
  },
  methods: {
    getEvaluationFormList() {
      let project_id = this.$route.params.id;
      getEvaluationFormList({ project_id }).then((res) => {
        this.forms = res.data;
        if (res.data.length) this.getEvaluationRuleTree();
      });
    },

    // 获取测评表规则树
    getEvaluationRuleTree() {
      getEvaluationRuleTree({
        evaluation_form_id: this.currentForm.id,
      }).then((res) => {
        this.rules = res.data;
      });
    },

    // 切换测评表
    switchForm(id, index) {
      this.currentFormIndex = index;
      this.getEvaluationRuleTree();
    },

    dialogShow(title, index) {
      let data = null;
      if (index !== undefined) {
        data = JSON.parse(JSON.stringify(this.forms[index]));
      }
      this.$refs.dialog.handleShow(title, data);
    },

    saveValue(data) {
      let project_id = this.$route.params.id;
      if (data.id) {
        editEvaluationForm({ ...data, project_id }).then(() => {
          this.getEvaluationFormList();
          this.$message({
            type: "success",
            message: "更新成功",
          });
        });
      } else {
        createEvaluationForm({ ...data, project_id }).then(() => {
          this.$message({
            type: "success",
            message: "创建成功",
          });
          this.getEvaluationFormList();
        });
      }
    },

    handleRuleCreate() {
      this.ruleForm = JSON.parse(JSON.stringify(defaultForm));
      this.ruleForm.parent_id = null;
      this.ruleForm.evaluation_form_id = this.currentForm
        ? this.currentForm.id
        : null;
      this.cuDialogVisible = true;
    },
  },
  components: {
    EvaluationRule,
    AddDialog,
    CreateUpdateDialog,
  },
  props: {},
};
</script>
<style lang="less" scoped>
.container {
  // margin-top: 64px;
  // width: 1200px;
  // margin: 64px auto 0 auto;
  // padding: 10px;
  display: flex;
}

.menu {
  position: relative;
  width: 240px;
  padding-top: 90px;
  border-right: 1px solid #e8e8e8;

  .items {
    height: calc(100vh - 120px);
  }

  .add {
    text-align: center;
    color: #1d82fc;
    cursor: pointer;
  }

  .item {
    padding: 10px;
    cursor: pointer;

    &:hover {
      background-color: #f2f6fd;
    }

    &.active {
      background: #409eff;
      color: #fff;
    }
  }
}

.form-container {
  flex: 1;
  margin-top: 64px;
  height: calc(100vh - 64px);
  overflow-y: auto;
  padding: 10px;
  position: relative;
  background-color: #f6f6f6;
}

.form {
  width: 1000px;
  min-height: 600px;
  background-color: white;
  margin: 0 auto;
  border: 1px solid #e1e6f0;
  padding: 30px;
  position: relative;
  border-radius: 5px;

  .title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
    position: relative;
  }

  .infos {
    padding: 20px 0;
    color: #666;

    .label {
      color: #333;
    }
  }

  .rules {
    .add {
      color: #409eff;
      text-align: center;
      cursor: pointer;
    }
  }
}

.empty-data {
  // position: absolute;
  min-height: 60px;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 480px;
  font-size: 14px;
  line-height: 480px;
  color: #909399;
  cursor: pointer;
  // transform: translate(-50%, -50%);
}

.empty-menu {
  min-height: 60px;
  text-align: center;
  line-height: 60px;
  color: #909399;
}

.editing {
  font-size: 16px;
  padding: 10px;
  // position: absolute;
  // right: 10%;
  // bottom: 0;
  color: #409eff;
}
</style>
